import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface SubscriptionStartEndCalendarStyles {
    SubscriptionCalendarWrap: GridContainerProps;
    subscriptionGirdItem?: GridItemProps;
    calendarLabel?: TypographyPresentationProps;
}

export const SubscriptionStartEndCalendarStyles: SubscriptionStartEndCalendarStyles = {
    subscriptionGirdItem: {
        css: css`
            flex-direction: column;
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
        `,
    },
    SubscriptionCalendarWrap: {
        css: css`
            & > div:first-child {
                flex-direction: row;
                flex-wrap: nowrap;
            }
        `,
    },
    calendarLabel: {
        css: css``,
    },
};

const styles = SubscriptionStartEndCalendarStyles;

type Props = WidgetProps;

const SunscriptionStartEndCalendar = () => {
    return (
        <GridContainer {...styles.SubscriptionCalendarWrap} data-test-selector="subscribed_Calendar">
            <GridItem {...styles.subscriptionGirdItem}>
                <Typography {...styles.calendarLabel}>{translate("Start Date")}</Typography>
            </GridItem>

            <GridItem {...styles.subscriptionGirdItem}>
                <Typography {...styles.calendarLabel}>{translate("End Date")}</Typography>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: SunscriptionStartEndCalendar,
    definition: {
        group: "Basic",
        displayName: "Subscription Calendar",
        // allowedContexts: ["MySubscriptionPage"],
    },
};

export default widgetModule;
